import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';

function Topbar() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('token') !== null);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    navigate('/login');
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  const closeDropdown = () => {
    setActiveDropdown(null);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    setActiveDropdown(null);
  };

  // SVG Icons - Fixed alignment and sizing
  const menuIconClass =
    'mr-2 flex h-6 w-6 items-center justify-center rounded-full bg-white/15 text-white/90 ring-1 ring-white/25 shadow-sm';
  const menuIconSvgClass = 'h-4 w-4';
  const icons = {
    dashboard: (
      <span className={menuIconClass}>
        <svg className={menuIconSvgClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4h7v7H4V4zM13 4h7v11h-7V4zM4 13h7v7H4v-7zM13 17h7v3h-7v-3z" />
        </svg>
      </span>
    ),
    users: (
      <span className={menuIconClass}>
        <svg className={menuIconSvgClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 20v-1a4 4 0 014-4h2a4 4 0 014 4v1" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 12a4 4 0 100-8 4 4 0 000 8z" />
        </svg>
      </span>
    ),
    services: (
      <span className={menuIconClass}>
        <svg className={menuIconSvgClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3l8 4-8 4-8-4 8-4z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 11l8 4 8-4" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 15l8 4 8-4" />
        </svg>
      </span>
    ),
    orders: (
      <span className={menuIconClass}>
        <svg className={menuIconSvgClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5h6" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 9h10" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 13h10" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17h7" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3h6a2 2 0 012 2v14a2 2 0 01-2 2H9a2 2 0 01-2-2V5a2 2 0 012-2z" />
        </svg>
      </span>
    ),
    marketing: (
      <span className={menuIconClass}>
        <svg className={menuIconSvgClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 11l16-5v12l-16-5v-2z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 13v5a2 2 0 002 2h2v-7" />
        </svg>
      </span>
    ),
    settings: (
      <span className={menuIconClass}>
        <svg className={menuIconSvgClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8a4 4 0 100 8 4 4 0 000-8z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.8 12a8.2 8.2 0 01.1-1.3l2.2-.3a6.4 6.4 0 01.7-1.7l-1.3-1.8a8.1 8.1 0 011.8-1.8l1.8 1.3a6.4 6.4 0 011.7-.7l.3-2.2a8.2 8.2 0 012.6 0l.3 2.2a6.4 6.4 0 011.7.7l1.8-1.3a8.1 8.1 0 011.8 1.8l-1.3 1.8a6.4 6.4 0 01.7 1.7l2.2.3a8.2 8.2 0 010 2.6l-2.2.3a6.4 6.4 0 01-.7 1.7l1.3 1.8a8.1 8.1 0 01-1.8 1.8l-1.8-1.3a6.4 6.4 0 01-1.7.7l-.3 2.2a8.2 8.2 0 01-2.6 0l-.3-2.2a6.4 6.4 0 01-1.7-.7l-1.8 1.3a8.1 8.1 0 01-1.8-1.8l1.3-1.8a6.4 6.4 0 01-.7-1.7l-2.2-.3c-.1-.4-.1-.9-.1-1.3z" />
        </svg>
      </span>
    ),
    chevronDown: (
      <svg className="w-3 h-3 ml-1 flex-shrink-0 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    ),
    logout: (
      <svg className="w-4 h-4 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
      </svg>
    ),
    hamburger: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    ),
    close: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    )
  };

  return (
    <nav className="sticky top-0 z-[100] shadow-lg">
      <div className="relative z-[110] bg-gradient-to-r from-[#EF5E28] to-[#002F53]">
        <div className="max-w-7xl mx-auto px-3 sm:px-4">
          <div className="flex justify-between items-center min-h-16 h-16 gap-2">
            <div className="flex min-w-0 flex-1 items-center">
              <div className="flex min-w-0 items-center">
                <Link
                  to="/"
                  className="text-base sm:text-xl lg:text-2xl font-bold text-white flex items-center min-w-0 max-w-full"
                >
                  <img
                    src="/app-logo.png"
                    alt="2do"
                    className="w-7 h-7 sm:w-8 sm:h-8 mr-2 sm:mr-3 flex-shrink-0 rounded-full"
                  />
                  <span className="truncate">Admin Panel</span>
                </Link>
              </div>

              {isAuthenticated && (
                <div className="hidden lg:ml-6 xl:ml-8 lg:flex lg:items-center lg:space-x-1 lg:flex-shrink-0">
                {/* Dashboard */}
                <Link to="/home" className="flex items-center px-3 py-2 rounded-md text-white hover:bg-white hover:bg-opacity-20 transition-all duration-200 font-medium">
                  {icons.dashboard}
                  <span className="whitespace-nowrap">Dashboard</span>
                </Link>

                {/* Users & Management Dropdown */}
                <div className="relative">
                  <button
                    onClick={() => toggleDropdown('users')}
                    className="flex items-center px-3 py-2 rounded-md text-white hover:bg-white hover:bg-opacity-20 transition-all duration-200 font-medium"
                  >
                    {icons.users}
                    <span className="whitespace-nowrap">Users & Team</span>
                    {icons.chevronDown}
                  </button>
                  {activeDropdown === 'users' && (
                    <div className="absolute top-full left-0 mt-2 w-60 bg-white rounded-lg shadow-xl z-50 border border-gray-200 overflow-hidden">
                      <div className="py-1">
                        <Link 
                          to="/users" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-green-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Users</span>
                        </Link>
                        <Link 
                          to="/contractors" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-blue-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Contractors</span>
                        </Link>
                        <Link 
                          to="/b2b" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-orange-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>B2B Dashboard</span>
                        </Link>
                        <Link 
                          to="/organizations" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-orange-300 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Organizations</span>
                        </Link>
                        <Link 
                          to="/verifications" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-yellow-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Verifications</span>
                        </Link>
                      </div>
                    </div>
                  )}
                </div>

                {/* Services & Catalog Dropdown */}
                <div className="relative">
                  <button
                    onClick={() => toggleDropdown('services')}
                    className="flex items-center px-3 py-2 rounded-md text-white hover:bg-white hover:bg-opacity-20 transition-all duration-200 font-medium"
                  >
                    {icons.services}
                    <span className="whitespace-nowrap">Catalog</span>
                    {icons.chevronDown}
                  </button>
                  {activeDropdown === 'services' && (
                    <div className="absolute top-full left-0 mt-2 w-60 bg-white rounded-lg shadow-xl z-50 border border-gray-200 overflow-hidden">
                      <div className="py-1">
                        <Link 
                          to="/categories" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-700 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-purple-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Categories</span>
                        </Link>
                        <Link 
                          to="/subcategories" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-700 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-purple-300 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Subcategories</span>
                        </Link>
                        <Link 
                          to="/services" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-700 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-indigo-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Services</span>
                        </Link>
                        <Link 
                          to="/combos" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-700 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-pink-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Combos</span>
                        </Link>
                        <Link 
                          to="/service-content-sections" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-700 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-teal-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Service content sections</span>
                        </Link>
                      </div>
                    </div>
                  )}
                </div>

                {/* Orders */}
                <Link to="/orders" className="flex items-center px-3 py-2 rounded-md text-white hover:bg-white hover:bg-opacity-20 transition-all duration-200 font-medium">
                  {icons.orders}
                  <span className="whitespace-nowrap">Orders</span>
                </Link>

                {/* Marketing & Promotions Dropdown */}
                <div className="relative">
                  <button
                    onClick={() => toggleDropdown('marketing')}
                    className="flex items-center px-3 py-2 rounded-md text-white hover:bg-white hover:bg-opacity-20 transition-all duration-200 font-medium"
                  >
                    {icons.marketing}
                    <span className="whitespace-nowrap">Marketing</span>
                    {icons.chevronDown}
                  </button>
                  {activeDropdown === 'marketing' && (
                    <div className="absolute top-full left-0 mt-2 w-60 bg-white rounded-lg shadow-xl z-50 border border-gray-200 overflow-hidden">
                      <div className="py-1">
                        <Link 
                          to="/blogs" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-blue-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Blogs</span>
                        </Link>
                        <Link 
                          to="/promo" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-green-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Promo Codes</span>
                        </Link>
                      </div>
                    </div>
                  )}
                </div>

                {/* Settings & Configuration Dropdown */}
                <div className="relative">
                  <button
                    onClick={() => toggleDropdown('settings')}
                    className="flex items-center px-3 py-2 rounded-md text-white hover:bg-white hover:bg-opacity-20 transition-all duration-200 font-medium"
                  >
                    {icons.settings}
                    <span className="whitespace-nowrap">Settings</span>
                    {icons.chevronDown}
                  </button>
                  {activeDropdown === 'settings' && (
                    <div className="absolute top-full right-0 mt-2 w-64 bg-white rounded-lg shadow-xl z-50 border border-gray-200 overflow-hidden">
                      <div className="py-1">
                        <Link 
                          to="/cities" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-gray-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Cities</span>
                        </Link>
                        <Link 
                          to="/insurance-slabs" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-orange-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Insurance Slabs</span>
                        </Link>
                        <div className="border-t border-gray-200 my-1"></div>
                        <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">App Editor</div>
                        <Link 
                          to="/app-editor" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-blue-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Home Editor</span>
                        </Link>
                        <Link 
                          to="/auto-home" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-cyan-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Auto Home Editor</span>
                        </Link>
                        <div className="border-t border-gray-200 my-1"></div>
                        <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">Integrations</div>
                        <Link 
                          to="/call-masking" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-violet-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Call Masking</span>
                        </Link>
                        <Link 
                          to="/jobs" 
                          onClick={closeDropdown}
                          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-200"
                        >
                          <div className="w-2 h-2 bg-emerald-400 rounded-full mr-3 flex-shrink-0"></div>
                          <span>Agenda Jobs</span>
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

            <div className="flex items-center flex-shrink-0">
              {isAuthenticated ? (
                <div className="flex items-center space-x-2 sm:space-x-3">
                  <button
                    type="button"
                    onClick={handleLogout}
                    className="hidden lg:flex items-center bg-red-500 hover:bg-red-600 text-white px-3 py-2 sm:px-4 rounded-lg text-sm sm:text-base font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
                  >
                    {icons.logout}
                    <span>Logout</span>
                  </button>
                  <button
                    type="button"
                    onClick={toggleMobileMenu}
                    className="lg:hidden flex items-center text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-md transition-colors duration-200 -mr-1"
                    aria-expanded={mobileMenuOpen}
                    aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
                  >
                    {mobileMenuOpen ? icons.close : icons.hamburger}
                  </button>
                </div>
              ) : (
                <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
                  <Link
                    to="/login"
                    className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-2 sm:px-4 rounded-lg text-sm sm:text-base font-medium transition-all duration-200 whitespace-nowrap"
                  >
                    Login
                  </Link>
                  <Link
                    to="/signup"
                    className="bg-white text-blue-600 hover:bg-gray-100 px-3 py-2 sm:px-4 rounded-lg text-sm sm:text-base font-medium transition-colors duration-200 whitespace-nowrap"
                  >
                    Sign Up
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Mobile / tablet menu */}
        {mobileMenuOpen && isAuthenticated && (
          <div className="lg:hidden bg-white border-t border-gray-200 max-h-[min(70vh,calc(100dvh-4rem))] overflow-y-auto overscroll-y-contain shadow-inner">
            <div className="px-4 py-3 space-y-2 pb-6">
            <Link 
              to="/home" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
            >
              {icons.dashboard}
              <span>Dashboard</span>
            </Link>
            
            <div className="border-t border-gray-200 my-2"></div>
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider px-3">Users & Team</div>
            <Link 
              to="/users" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-green-400 rounded-full mr-3"></div>
              <span>Users</span>
            </Link>
            <Link 
              to="/contractors" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-blue-400 rounded-full mr-3"></div>
              <span>Contractors</span>
            </Link>
            <Link 
              to="/b2b" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-orange-400 rounded-full mr-3"></div>
              <span>B2B Dashboard</span>
            </Link>
            <Link 
              to="/organizations" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-orange-300 rounded-full mr-3"></div>
              <span>Organizations</span>
            </Link>
            <Link 
              to="/verifications" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-yellow-400 rounded-full mr-3"></div>
              <span>Verifications</span>
            </Link>
            
            <div className="border-t border-gray-200 my-2"></div>
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider px-3">Catalog</div>
            <Link 
              to="/categories" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-purple-400 rounded-full mr-3"></div>
              <span>Categories</span>
            </Link>
            <Link 
              to="/subcategories" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-purple-300 rounded-full mr-3"></div>
              <span>Subcategories</span>
            </Link>
            <Link 
              to="/services" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></div>
              <span>Services</span>
            </Link>
            <Link 
              to="/combos" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-pink-400 rounded-full mr-3"></div>
              <span>Combos</span>
            </Link>
            <Link 
              to="/service-content-sections" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-teal-400 rounded-full mr-3"></div>
              <span>Service content sections</span>
            </Link>
            
            <div className="border-t border-gray-200 my-2"></div>
            <Link 
              to="/orders" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
            >
              {icons.orders}
              <span>Orders</span>
            </Link>
            
            <div className="border-t border-gray-200 my-2"></div>
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider px-3">Marketing</div>
            <Link 
              to="/blogs" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-blue-400 rounded-full mr-3"></div>
              <span>Blogs</span>
            </Link>
            <Link 
              to="/promo" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-green-400 rounded-full mr-3"></div>
              <span>Promo Codes</span>
            </Link>
            
            <div className="border-t border-gray-200 my-2"></div>
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider px-3">Settings</div>
            <Link 
              to="/cities" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-gray-400 rounded-full mr-3"></div>
              <span>Cities</span>
            </Link>
            <Link 
              to="/insurance-slabs" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-orange-400 rounded-full mr-3"></div>
              <span>Insurance Slabs</span>
            </Link>
            <Link 
              to="/app-editor" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-blue-400 rounded-full mr-3"></div>
              <span>Home Editor</span>
            </Link>
            <Link 
              to="/auto-home" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-cyan-400 rounded-full mr-3"></div>
              <span>Auto Home Editor</span>
            </Link>
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider px-3 mt-2">Integrations</div>
            <Link 
              to="/call-masking" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-violet-400 rounded-full mr-3"></div>
              <span>Call Masking</span>
            </Link>
            <Link 
              to="/jobs" 
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center px-6 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <div className="w-2 h-2 bg-emerald-400 rounded-full mr-3"></div>
              <span>Agenda Jobs</span>
            </Link>
            
            <div className="border-t border-gray-200 my-2"></div>
            <button
              onClick={() => {
                handleLogout();
                setMobileMenuOpen(false);
              }}
              className="w-full flex items-center px-3 py-2 text-red-600 hover:bg-red-50 rounded-md transition-colors"
            >
              {icons.logout}
              <span>Logout</span>
            </button>
          </div>
        </div>
        )}
      </div>

      {/* Dismiss layer: behind nav content (z-[110]) so links stay clickable; dims on small screens when menu open */}
      {(activeDropdown || mobileMenuOpen) && (
        <div
          className={
            mobileMenuOpen
              ? 'fixed inset-0 z-[105] bg-black/25 lg:bg-transparent'
              : 'fixed inset-0 z-[105] hidden lg:block bg-transparent'
          }
          aria-hidden="true"
          onClick={() => {
            closeDropdown();
            setMobileMenuOpen(false);
          }}
        />
      )}
    </nav>
  );
}

export default Topbar;
